import React, { useRef, useEffect, useState } from 'react';
import { useScroll, useTransform, motion } from 'framer-motion';
import { YoutubeCard } from './YoutubeCard';
import { useFollowPointer } from "../../hook/useFollowPointer";

type YoutubeType = {
    link: string;
    src: string;
};

type YoutubeDesktopProps = {
    youtubes: YoutubeType[];
};

const responsiveTop = (width: number): [number, number] => {
    if (width > 1023) {
        return [0, 4];
    } else {
        return [0, 3];
    }
};


export default function YoutubeDesktop({ youtubes }: YoutubeDesktopProps) {

    const youtube = useRef(null);

    const { scrollYProgress } = useScroll({
        target: youtube,
        offset: ["start end", "end start"]
    })

    const x1 = useTransform(scrollYProgress, [0, 1], [0, 200])
    const x2 = useTransform(scrollYProgress, [0, 1], [0, -200])

    const [rangeTop, setRangeTop] = useState<[number, number]>(responsiveTop(window.innerWidth));

    const updateResponsiveTop = () => {
        setRangeTop(responsiveTop(window.innerWidth));
    };

    useEffect(() => {
        window.addEventListener("resize", updateResponsiveTop);

        return () => {
            window.removeEventListener("resize", updateResponsiveTop);
        };
    }, []);

    const [startImage, endImage] = rangeTop;

    return (
        <section ref={youtube}>
            <motion.div className="grid grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-10 4xl:gap-24 relative left-[-16vw] lg:left-[-20vw] 4xl:left-[-10vw] w-[110vw]"
                style={{ x: x1 }}
            >
                {
                    youtubes.slice(startImage, endImage).map((youtube, index) => (
                        <YoutubeCard link={youtube.link} src={youtube.src} key={index} />
                    ))
                }
            </motion.div>
            <motion.div className="pt-8 grid grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-10 4xl:gap-24 relative right-[-7vw] lg:right-[-10vw] 4xl:right-[-4vw] w-[110vw]"
                style={{ x: x2 }}
            >
                {
                    youtubes.slice(endImage, endImage * 2).map((youtube, index) => (
                        <YoutubeCard link={youtube.link} src={youtube.src} key={index} />
                    ))
                }
            </motion.div>
        </section>
    );
}


